import React from "react";
import { ModeRendererProps } from "./types";

export function MeshMode({ brand }: ModeRendererProps) {
  return (
    <g transform="translate(397 540)">
      <clipPath id="meshClip">
        <circle r="300" />
      </clipPath>
      <g clipPath="url(#meshClip)">
        {Array.from({ length: 14 }).map((_, r) => (
          <g key={r}>
            {Array.from({ length: 20 }).map((_, c) => {
              const x = -320 + c * 32 + (r % 2 ? 16 : 0);
              const y = -300 + r * 42;
              const nx = x + (c % 3 === 0 ? 10 : -6);
              const ny = y + (r % 2 === 0 ? -8 : 10);
              return (
                <g key={c}>
                  <line x1={x} y1={y} x2={nx} y2={ny} stroke={brand.violet} strokeOpacity="0.25" />
                  <circle cx={x} cy={y} r="2.6" fill={(r + c) % 3 === 0 ? brand.green : brand.aqua} />
                </g>
              );
            })}
          </g>
        ))}
      </g>
      <circle r="300" fill="none" stroke={brand.white} strokeWidth="4" />
    </g>
  );
}
